module.exports = __webpack_public_path__ + "img/风扇.81d5bdf1.svg";